<script>
import UtilsMixin from "@/mixins/utils";

export default {
  components: {},
  props: {
    distributor: Object,
    data: Object,
    me: Object,
  },
  data() {
    return {
      timePrint: {
        year: new Date().getFullYear(),
        month:
          new Date().getMonth() >= 10
            ? new Date().getMonth() + 1
            : `0${new Date().getMonth() + 1}`,
        day:
          new Date().getDate() >= 10
            ? new Date().getDate()
            : `0${new Date().getDate()}`,
        hour: new Date().getHours(),
        min: new Date().getMinutes(),
        sec: new Date().getSeconds(),
      },
    };
  },
  mixins: [UtilsMixin],
};
</script>

<template>
  <div class="page-landscape">
    <div class="d-flex justify-content-between">
      <div>
        <p class="text-uppercase mb-2 font-size-16">
          {{ distributor.distributor_name }}
        </p>
        <p class="text-uppercase mb-2 font-size-16">
          Địa chỉ: {{ distributor.distributor_address }}
        </p>
        <p class="text-uppercase mb-0 font-size-16">
          Tel: {{ distributor.distributor_phone }}
        </p>
      </div>
      <div></div>
    </div>
    <h2 class="text-uppercase text-center pt-3">Báo cáo công nợ cuối kỳ</h2>
    <div class="print-content mb-3">
      <p class="text-left mt-3 mb-1" v-if="data.date">
        Đến {{ formatDate(data.date[1]) }}
      </p>
      <p class="text-left mb-1" v-if="data.customer">
        Khách hàng: {{ data.customer }}
      </p>
      <p class="text-left" v-if="data.salesman">
        Salesman: {{ data.salesman }}
      </p>
    </div>

    <table class="table table-bordered font-size-16 border-black">
      <tr>
        <th>STT</th>
        <th>Mã khách hàng</th>
        <th>Tên khách hàng</th>
        <th>Tổng công nợ</th>
      </tr>
      <tr v-for="(item, key) of data.details" :key="key">
        <td>{{ formatPrice(key + 1) }}</td>
        <td>{{ item.customer_id }}</td>
        <td>{{ item.customer_name }}</td>
        <td>{{ formatPrice(item.debt_amount) }}</td>
      </tr>
      <tr v-if="data.summary" class="font-weight-bold">
        <td colspan="3">Tổng</td>
        <td>{{ formatPrice(data.summary.debt_amount) }}</td>
      </tr>
      <tfoot class="footer-repeat no-border">
        <!-- add repeated tfoot for extra space -->
        <tr class="no-border">
          <td class="no-border">&nbsp;</td>
        </tr>
      </tfoot>
    </table>

    <div class="print-footer d-flex justify-content-around font-size-16 pt-3">
      <div>
        <p class="invisible">-</p>
        <p class="font-weight-medium text-center mb-0">Xác nhận của NVBH</p>
        <p class="font-italic text-center">(Ký, họ tên)</p>
      </div>
      <div>
        <p>
          Ngày {{ timePrint.day }} tháng {{ timePrint.month }} năm
          {{ timePrint.year }}
        </p>
        <p class="font-weight-medium text-center mb-0">Người lập biểu</p>
        <p class="font-italic text-center">(Ký, họ tên)</p>
      </div>
    </div>
  </div>
</template>
